import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class ModalUpdateUser extends Component {
  render() {
    let { show, sendUpdateUser, close, name, entityName } = this.props;
    return (
      <Modal
        isOpen={show}
        toggle={close}
        className={"modal-info " + this.props.className}
      >
        <ModalHeader toggle={close}>
          ¿Esta seguro de Actualizar {entityName}?
        </ModalHeader>
        <ModalBody>
          <p>Esta por actualizar a "{name}"</p>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={sendUpdateUser} className="">
            Actualizar
          </Button>
          <Button color="secondary" onClick={close}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ModalUpdateUser;
